/**
 * EvidenceSection — "certificates vs. deployed systems" credibility block.
 */

import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ITEM_KEYS = [
  { titleKey: "EvidenceSection.item1Title", detailKey: "EvidenceSection.item1Detail" },
  { titleKey: "EvidenceSection.item2Title", detailKey: "EvidenceSection.item2Detail" },
  { titleKey: "EvidenceSection.item3Title", detailKey: "EvidenceSection.item3Detail" },
  { titleKey: "EvidenceSection.item4Title", detailKey: "EvidenceSection.item4Detail" },
];

export default function EvidenceSection() {
  const { t } = useTranslation("home");
  return (
    <Box id="evidence" component="section" sx={{ scrollMarginTop: "80px" }}>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" }, gap: { xs: 4, md: 6 }, alignItems: "center" }}>
        <Box>
          <Typography component="span" sx={{ fontSize: 14, fontWeight: 500, color: "secondary.main", display: "block", mb: 1.5 }}>
            {t("EvidenceSection.eyebrow")}
          </Typography>
          <Typography sx={{ fontSize: { xs: 22, md: 28 }, fontWeight: 500, lineHeight: 1.25 }}>
            {t("EvidenceSection.quotePlain")}{" "}
            <Box component="span" sx={{ color: "secondary.main" }}>
              {t("EvidenceSection.quoteEmphasis")}
            </Box>
          </Typography>
          <Typography sx={{ mt: 2, color: "text.secondary", fontSize: 16 }}>
            {t("EvidenceSection.lead")}
          </Typography>
        </Box>
        <Box sx={{ borderRadius: "14px", border: 1, borderColor: "divider", bgcolor: "background.paper", p: 2.5 }}>
          <Stack direction="row" justifyContent="space-between" sx={{ mb: 1.5 }}>
            <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{t("EvidenceSection.cardHeading")}</Typography>
            <Typography sx={{ fontSize: 12, color: "text.secondary", fontFamily: '"JetBrains Mono", ui-monospace, monospace' }}>
              {t("EvidenceSection.cardTarget")}
            </Typography>
          </Stack>
          <Stack spacing={0}>
            {ITEM_KEYS.map((item, i) => (
              <Stack
                key={item.titleKey}
                direction="row"
                spacing={1.5}
                alignItems="flex-start"
                sx={{ py: 1.25, borderTop: i === 0 ? "none" : "1px solid", borderColor: "divider" }}
              >
                <CheckCircleIcon sx={{ fontSize: 18, color: "success.main", mt: 0.2 }} />
                <Box>
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>{t(item.titleKey)}</Typography>
                  <Typography sx={{ fontSize: 12.5, color: "text.secondary" }}>{t(item.detailKey)}</Typography>
                </Box>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
